import { Flex } from '@chakra-ui/react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { TextArea } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import { CONTENT_CHARACTER_LIMIT } from '../constants';
import { trimLeadingWhitespace, validateRequiredTrimmedText } from '../helpers';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

type Props = {
  control: Control<FieldFormValues>;
  errors: FieldErrors<FieldFormValues>;
  isFormDisabled: boolean;
};

const LabelContentField: React.FC<Props> = ({
  control,
  errors,
  isFormDisabled
}) => {
  return (
    <Flex direction="column" gap={2}>
      <FieldLabel label="Checkbox Content" subText="" isRequired />

      <Controller
        name="labelContent"
        control={control}
        rules={{
          validate: value =>
            validateRequiredTrimmedText({
              value,
              label: 'Content',
              isDisabled: isFormDisabled
            }),
          maxLength: {
            value: CONTENT_CHARACTER_LIMIT,
            message: `Content cannot exceed ${CONTENT_CHARACTER_LIMIT} characters`
          }
        }}
        render={({ field }) => (
          <TextArea
            name={field.name}
            value={field.value}
            characterLimit={CONTENT_CHARACTER_LIMIT}
            onChange={event =>
              field.onChange(trimLeadingWhitespace(event.target.value))
            }
            placeholder="Enter content"
            resize="vertical"
            isInvalid={!isFormDisabled && Boolean(errors.labelContent)}
            errorMessage={
              !isFormDisabled ? errors.labelContent?.message : undefined
            }
            isReadOnly={isFormDisabled}
          />
        )}
      />
    </Flex>
  );
};

export default LabelContentField;
